

export default function PostInfo({ user, created }) {

   const formatData = (date) => {
        let d = new Date(date);
        let today_year = new Date().getFullYear();
        let today_day = new Date().getDate();
        let today_month = new Date().getMonth() + 1;

        let da = d.getDate();
        let mo_number = d.getMonth() + 1;
        let mo = new Intl.DateTimeFormat('it', { month: 'short' }).format(d).toLowerCase();
        let ye = d.getFullYear();
        let hr = d.getHours();
        let mi = d.getMinutes();
        if(mi.toString().length===1){
            mi='0'+mi;
        }
        //let se = d.getSeconds();

        let timetostamp = '';
        let ieri_oggi = null;
        if(today_year > ye){
            timetostamp = da+' '+mo+' '+ye+' alle '+hr+':'+mi;
        } else {
            //se è nello stesso anno controllo se è anche lo stesso giorno per scrivere 'oggi' o 'ieri'
            if (da === today_day && mo_number === today_month) {
                ieri_oggi = 'oggi';
            } else if ((today_day-da) === 1 && mo_number === today_month) {
                ieri_oggi = 'ieri';
            }

            if(ieri_oggi) {
                timetostamp = ieri_oggi+' alle '+hr+':'+mi;
            } else {
                timetostamp = da+' '+mo+' alle '+hr+':'+mi;
            }
        }

        return timetostamp;
    };


    return (
    <p className="card-text">
        <small className="text-muted">
        <b className="d-inline">{user + " · "}</b>
        {formatData(created)}
        </small>
    </p>
    );
}
